/**
 * The words a paged list says when its feed is refused. They live apart from the
 * feed hook (hooks/useCollectionItems) so a component that only SAYS them (the
 * list's footer) does not import the network to do it.
 */
export const RATE_LIMITED_TEXT = 'keepr is getting too many requests. Try again in a moment.';
